import Vue from "vue";
import VWave from 'v-wave';
import NumericDirective from './NumericDirective'

Vue.use(VWave);
Vue.use(NumericDirective);

Vue.directive('money', {
	bind(el, binding){
		el.innerText = Vue.prototype.$toLocalCurrency(binding.value);
	},
	update(el, binding){
		el.innerText = Vue.prototype.$toLocalCurrency(binding.value);
	},
})
